import { useContext } from 'react';

import { DatePickerContext } from '../DatePickerProvider';
import { DatePickerProviderProps } from '../types';

export const useDatePickerContext = <T = DatePickerProviderProps>() => {
  return useContext(DatePickerContext) as T;
};
